module.exports = __webpack_public_path__ + "static/media/i51a.e0ff0146.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/i51a.svg
// module id = 189
// module chunks = 12